<template>
  <div>
    <template v-if="interview.type === types.ONLINE_INTERVIEW">
      <OnlineInterview
        :key="key"
        :vacancy="vacancy"
        :candidate="candidate"
        :interview="interview"
        :are-questions-equal="areQuestionsEqual"
        @online-interview-played="$emit('online-interview-played')"
      />
    </template>
    <template v-else-if="interview.type === types.VIDEO_CALL">
      <VideoCall
        :key="key"
        :candidate="candidate"
        :interview="interview"
      />
    </template>
    <template v-else-if="interview.type === types.OFFICE_INTERVIEW">
      <OfficeInterview
        :key="key"
        :vacancy="vacancy"
        :readonly="readonly"
        :candidate="candidate"
        :interview="interview"
      />
    </template>
    <template v-else-if="interview.type === types.UPLOADED_VIDEO">
      <UploadedVideoInterview
        :key="key"
        :candidate="candidate"
        :interview="interview"
      />
    </template>
  </div>
</template>

<script>
import { candidateInterviewType } from '@/enums';
import OnlineInterview from './OnlineInterview.vue';
import VideoCall from './VideoCall.vue';
import OfficeInterview from './OfficeInterview.vue';
import UploadedVideoInterview from './UploadedVideoInterview.vue';

export default {
  name: 'CandidateInterview',
  components: {
    UploadedVideoInterview, OfficeInterview, VideoCall, OnlineInterview,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    interview: {
      type: Object,
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      types: candidateInterviewType,
    };
  },
  computed: {
    key() {
      return Date.now();
    },
  },
};
</script>

<style scoped>

</style>
